/**
 * Created by staffanrantzow on 15/03/16.
 */

/* @flow */
import React from 'react';
import { InfoService, Utils } from 'frilans-finans';

export class InfoBoxList extends React.Component {

  constructor (props) {
    super(props);

    this.state = {
      info: [],
      pendingRequest: null
    };

    this.renderBox = this.renderBox.bind(this);
  }

  componentDidMount () {
    this.fetch();
  }

  componentWillUnmount () {
    if (this.state.pendingRequest && this.state.pendingRequest.cancel) {
      this.state.pendingRequest.cancel();
    }
  }

  fetch () {
    let pendingRequest = InfoService.get();
    pendingRequest.promise.then((response) => {
      this.setState({
        info: response
      });
    });

    this.setState({
      pendingRequest: pendingRequest
    });
  }

  createMarkup (html) {
    return {__html: html};
  }

  render () {
    const boxes = this.state.info.map(this.renderBox);
    return (
      <span>{boxes}</span>
    );
  }

  renderBox (info, key) {
    return (
      <div className='info-box' key={key}>
        <h2>{info.title}</h2>
        <div dangerouslySetInnerHTML={this.createMarkup(Utils.getLineBreaks(info.text))}></div>
      </div>
    );
  }

}

export default InfoBoxList;



/** WEBPACK FOOTER **
 ** ./src/components/left-page-section/info-box/info-box-list.js
 **/